import { DateObject, encode } from '@capsicum/common';
import { useMemo } from 'react';

import { type WCPledgeTeam } from '../models';

export const useWCPledgeTokenFormats = (country: WCPledgeTeam) => {
	return useMemo(() => {
		const tokenAmount = `1 ${country?.currency?.shortCode ?? country.countryCode}`;
		const tokenPrice = `${Number((country as WCPledgeTeam & { priceInUSD?: string }).priceInUSD ?? 0)?.toFixed(2)} USD`;
		const tokenAltPrice = `(${encode('doubleTilde')}${Number(country.priceInCHZ ?? 0)?.toFixed(2)} CHZ)`;
		const hasStakingPeriodEnded = !!(country.endDate && new DateObject(country.endDate).isBefore(new DateObject()));

		return { hasStakingPeriodEnded, tokenAltPrice, tokenAmount, tokenPrice };
	}, [country]);
};
